const processColumn = (node: any) => {
    const data = node.data || (node.data = {})
    data.hProperties = node.attributes
    const newNode = node

    data.hProperties.class = 'columns-container-' + node.attributes.count;
    delete newNode.attributes.count;
}

export default processColumn